'use client'

import { ProgramRelatedElements, Room } from '@/types/Misc'
import React, { ReactElement, ReactNode, useContext, useEffect } from 'react'
import { useTranslations } from 'next-intl'
import { HotelPageContext } from '@/components/hotel/HotelPageContext'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { faInfoCircle } from '@awesome.me/kit-dc19441bb1/icons/classic/light'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

function ProgramsHeading(props: { heading: string }): ReactElement {
  return (
    <h2
      className="pb-6 text-xl font-semibold text-stone-900 sm:font-medium md:text-2xl"
      id="offers"
    >
      {props.heading}
    </h2>
  )
}

function NoProgramsMessage() {
  const t = useTranslations('Hotel.Programs.Programs')
  return (
    <div
      className="flex gap-4 rounded-md bg-yellow-warning p-6 text-yellow-warning-text"
      id="offers"
    >
      <FontAwesomeIcon
        icon={faInfoCircle as IconProp}
        className="h-5 bg-white bg-yellow-warning p-0.5"
      />
      <div
        className="prose text-yellow-warning-text prose-a:text-yellow-warning-text hover:prose-a:text-yellow-warning-text "
        dangerouslySetInnerHTML={{
          __html: t.raw('noProgrammsAvailableInfoBox') as string,
        }}
      />
    </div>
  )
}

export function Programs(props: {
  rooms: Room[]
  hotelCode: string
  prevIcon: ReactElement
  nextIcon: ReactElement
  bestOfferBox: ReactNode
  flexTarifBox: ReactNode
  staticPrograms: ProgramRelatedElements
}): ReactElement {
  const t = useTranslations('Hotel.Programs.Programs')
  const { programs, additionalPrograms } = useContext(HotelPageContext)

  useEffect(() => {
    if (new URLSearchParams(window?.location.search).has('p')) {
      //jump to the programs section
      const element = document.getElementById('offers')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  })

  const programsHeading = <ProgramsHeading heading={t('programsMatchingHeading')} />

  return (
    <>
      {programs.length === 0 && additionalPrograms.length === 0 && (
        <>
          {programsHeading}
          <NoProgramsMessage />
        </>
      )}

      {programs.length > 0 && (
        <>
          <ProgramsHeading heading={t('programsMatchingHeading')} />
          {programs.map((program) => props.staticPrograms[program.programCode])}
        </>
      )}
      {additionalPrograms.length > 0 && (
        <>
          <ProgramsHeading heading={t('programsOthersHeading')} />
          {additionalPrograms.map((program) => props.staticPrograms[program.programCode])}
        </>
      )}
    </>
  )
}
